import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import { MdFileDownload } from "react-icons/md";
import { DIMENSIONS } from "utils/Dimensions";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";
import { cloneDeep } from "lodash";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const exportOptions = [
  { title: "CSV Export", format: "csv" },
  { title: "Excel Export (.xlsx)", format: "xlsx" },
  { title: "Excel Export (.xml)", format: "xml" },
];
export default class Options extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  export = (item) => {
    var params = {
      exportMode: item.format,
      skipPinnedBottom: true,
      fileName: this.props.store.listConfig.list.name,
      sheetName: this.props.store.listConfig.list.name,
      columnKeys: this.props.store.columnDefs.map((columnDef) => {
        if (columnDef.colId != "+" && columnDef.colId != "userEvents" ) return columnDef.colId;
      }),
      columnGroups: true,
      shouldRowBeSkipped: function (node, api, context) {
        return typeof node.node.data == "undefined" || node.node.data.row_id == "+";
      },
      // processCellCallback: function(node , api, context) {
      //   let options = node?.column?.colDef?.cellRendererParams
      //   let value = node.value
      //   if (options && options.columnTypeId) {
      //     if (options.columnTypeId == 22) {
      //       let decimals =
      //         options.columnOptions && options.columnOptions.decimals
      //           ? options.columnOptions.decimals
      //           : 2;
      //       value = isNaN(value)
      //         ? value
      //         : (Number(value) * 100).toFixed(decimals - 2) + " %";
      //     } else if (
      //       !isNaN(value) &&
      //       options.columnTypeId == 10 &&
      //       options.columnOptions?.column_type == "percentage"
      //     ) {
      //       let decimals = String(value).includes(".")
      //         ? String(value).split(".")[1].length
      //         : 2;
      //       value = (Number(value) * 100).toFixed(decimals - 2) + " %";
      //     }
      //   }
      //   return value;
      // }
    };
    if (item.format == "csv") this.props.gridApi.exportDataAsCsv(params);
    else this.props.gridApi.exportDataAsExcel(params);

    this.handleClose();
  };

  exportLazyLoadData = async (item, rowCount) => {
    let columns = this.props.store.columnsFormatted,
      subSheetsCount = 0,
      isIncludeSubsheets = false,
      format =
        this.props.store.shouldLoadAllRows == true
          ? item.format
            ? item.format
            : "xlsx"
          : item.format == "csv"
          ? item.format
          : "xlsx";
    if (this.props.store.view.is_main_view == "1") {
      columns.forEach((col) => {
        if (col.column_type_id == "6") {
          subSheetsCount = 1;
          return false;
        }
      });
    }
    await window.appStore.notificationStore.confirm({
      description: (
        <>
          <div>
            Are you sure you want to export {rowCount - this.props.store.newRows.length} rows?
          </div>
          {subSheetsCount > 0 && (
            <>
              <br />
              <div>
                <input
                  type="checkbox"
                  onChange={() => {
                    isIncludeSubsheets = !isIncludeSubsheets;
                  }}
                  id="include_subsheets"
                /> Include subsheets for exporting
              </div>
            </>
          )}
        </>
      ),
    });

    if (
      format == "xml" &&
      isIncludeSubsheets == false &&
      this.props?.store?.shouldLoadAllRows == true
    ) {
      this.export(item);
      return;
    }

    let proxy = this.getProxyConfig(),
      subsheetsIncluded =
        subSheetsCount > 0 &&
        isIncludeSubsheets
          ? 1
          : 0,
      params = proxy.extraParams;

    try {
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        let value = params[key];
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        formData.append(key, value);
      });
      this.props.store.isExportingLazyLoadData = true;

      await axios({
        method: "POST",
        url:
          proxy.url +
          "?is_export=1&include_subsheets=" +
          subsheetsIncluded +
          "&format=" +
          format,
        data: formData,
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          this.props.store.containerStore.listConfig.list.name +
            "." +
            (subsheetsIncluded == 1 ? "xlsx" : format)
        );
        document.body.appendChild(link);
        link.click();
        this.props.store.isExportingLazyLoadData = false;
      });
    } catch (e) {
      this.props.store.isExportingLazyLoadData = false;
      if (e.response?.data) {
        throw {
          message: e.response?.data?.messages || "Api Failed",
          response: e.response.data,
        };
      } else {
        throw e;
      }
    }
  };

  getProxyConfig = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const criteria = this.props.store.gridApi?.getFilterModel()
      ? this.props.store.getCriteriaStringFromFilterModel(
          this.props.store.gridApi?.getFilterModel()
        )
      : "";
    if (
      this.props.store.view.id <= 0 ||
      this.props.store.isCriteriaModified ||
      this.props.store.isNewColumnAdded
    ) {
      const view = cloneDeep(this.props.store.view);
      view.id = -1;
      view.criteria =
        this.props.store.modifiedCriteria ??
        this.props.store.view.criteria;
      const newColumns = [
        ...view.options.columns,
        ...this.props.store.newColumns,
      ];
      view.options.columns = newColumns;
      return {
        url: baseUrl + "/views/run-view",
        extraParams: {
          list_id: this.props.store.listId,
          view: view,
          criteria: criteria,
        },
      };
    } else {
      return {
        url: baseUrl + "/views/get-view-data",
        extraParams: {
          list_id: this.props.store.listId,
          view_id: this.props.store.view.id,
          criteria: criteria,
        },
      };
    }
  };

  render() {
    return (
      <StyledRowHeightDiv className="d-flex actions">
        <MdFileDownload
          size={18}
          color={COLORS.TEXT_COLOR}
          data-tip="Export"
          data-for="exportTooltip"
          onClick={this.handleClick}
        />
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {exportOptions.map((item, index) => (
            <MenuItem
              key={index}
              className={"exportItem"}
              onClick={async () => {
                this.handleClose();
                let rowCount;
                if(this.props.store.isGridGrouped == true) {
                  rowCount = this.props.store.currentRowsCount;
                } else {
                  rowCount = this.props.gridApi.getModel().getRowCount() - 1;
                }
                try {
                  if (this.props.store.isLazyLoadEnabled == true) {
                    this.exportLazyLoadData(item, rowCount);
                  } else if (this.props?.store?.shouldLoadAllRows == true) {
                    this.exportLazyLoadData(item, rowCount + this.props.store?.newRows?.length);
                  } else {
                    await window.appStore.notificationStore.confirm({
                      description: (
                        <>Are you sure you want to export {rowCount} rows?</>
                      ),
                    });
                    this.export(item);
                  }
                } catch (e) {
                  console.log(e);
                }
              }}
            >
              {item.title}
            </MenuItem>
          ))}
        </Menu>
      </StyledRowHeightDiv>
    );
  }
}

const StyledRowHeightDiv = styled.div`
  margin: 3px;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
`;
